import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SortState } from '../../types/Spreadsheet';
import { RootState } from '../store';

interface SortingState {
  sorting: SortState;
}

const initialState: SortingState = {
  sorting: null
};

const sortingSlice = createSlice({
  name: 'sorting',
  initialState,
  reducers: {
    setSorting( state, action: PayloadAction<SortState> ) {
      state.sorting = action.payload;
    },
    clearSorting( state ) {
      state.sorting = null;
    }
  }
});

export const { setSorting, clearSorting } = sortingSlice.actions;
export const selectSorting = ( state: RootState ) => state.spreadsheet.sorting.sorting;
export default sortingSlice.reducer;